/**
 * Created by roman.kupin on 2/20/2018.
 */

import { LicenseType, Permissions } from 'account-hybrid/core/authentication';
import * as AdminReportsComponent from "./adminReports.component";
import adminReportsReducer from "./reducers/index";
import { StateConfig } from "./state.config";

declare let angular;

export const MODULE = angular.module("AccountApp.v2.AdminReports", []);
export const REDUCER = { adminReports: adminReportsReducer };
export const PERMISSIONS = Permissions.FliptoAdministration;
export const LICENSE = LicenseType.None;

MODULE.config(StateConfig);
MODULE.component(AdminReportsComponent.NAME, AdminReportsComponent.OPTIONS);

